module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PdfDetailView.js"));
	}, "PdfDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PdfDetailView!./src/pages/Learn/Course/PdfDetail/PdfDetailView.js
// module id = 1211
// module chunks = 438